import { DcSccBaseModel } from 'dc-scc'

export class V1 extends DcSccBaseModel
{
	protected _clientObj=null;
	protected _cache={data: null, exists:null, meta:null};
	protected _ddsId=null;
	protected _ddsAuth=null;
	protected _updateCbs=[];
	protected _deleteCbs=[];

	public setConfig(cObj, id, auth)
	{
		this._clientObj	= cObj;
		this._ddsId		= id;
		this._ddsAuth	= auth;
		return this;
	}
	public async initialize()
	{
		var reqObj			= await this._clientObj.newRequest();
		reqObj.setL1("Stores").setL2("Get").setL3("Subscription").setL4("ById");
		reqObj.addReq("id", this._ddsId).addReq("auth", this._ddsAuth);
		var rObj			= await reqObj.getResponse(true);
		this._cache.data	= rObj.data;
		this._cache.meta	= rObj.meta;
		this._cache.exists	= true;
		return this;
	}
	public getClient()
	{
		return this._clientObj;
	}
	public getDdsId()
	{
		return this._ddsId;
	}
	public addUpdateCb(cbObj, cbMethod)
	{
		this._updateCbs.push([cbObj, cbMethod]);
		return this;
	}
	public addDeleteCb(cbObj, cbMethod)
	{
		this._deleteCbs.push([cbObj, cbMethod]);
		return this;
	}
	public removeDeleteCb(obj, method)
	{
		Object.keys(this._deleteCbs).forEach(index => {
			var cb	= this._deleteCbs[index];
			if (cb[0] === obj && cb[1] === method) {
				delete this._deleteCbs[index];
			}
		});
		return this;
	}
	public removeUpdateCb(obj, method)
	{
		Object.keys(this._updateCbs).forEach(index => {
			var cb	= this._updateCbs[index];
			if (cb[0] === obj && cb[1] === method) {
				delete this._updateCbs[index];
			}
		});
		return this;
	}
	public getCache()
	{
		//store in object so clients can use the object directly for realtime updates
		//else the variable is reset and what ever the client is using the data for becomes disconnected
		return this._cache;
	}
	public getData()
	{
		return this.getCache().data;
	}
	public getExists()
	{
		return this.getCache().exists;
	}
	public getMeta()
	{
		return this.getCache().meta;
	}
	public getKey(key, throwOnErr=true)
	{
		if (
			typeof this._cache["data"] == "object"
			&& typeof this._cache["data"][key] != "undefined"
		) {
			return this._cache["data"][key];
		} else if (throwOnErr === true) {
			throw this.getMtm().newException("Key: " + key + ", does not exist");
		} else {
			return null;
		}
	}
	public cacheUpdate(data, meta)
	{
		this.getCache().data	= data;
		this.getCache().meta	= meta;
		Object.keys(this._updateCbs).forEach(index => {
			var cb	= this._updateCbs[index];
			try {
				cb[0][cb[1]](this);
			} catch (e) {
				//Control yourself!
			}
		});
		return this;
	}
	public cacheDelete()
	{
		Object.keys(this._deleteCbs).forEach(index => {
			var cb	= this._deleteCbs[index];
			try {
				cb[0][cb[1]](this);
			} catch (e) {
				//Control yourself!
			}
		});
		this.getCache().exists	= false;
		this.getService().getStores().clearCache(this);
		return this;
	}
}